import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader


import Vue from 'vue'
import Vuetify from 'vuetify/lib'
// import plugin
import { TiptapVuetifyPlugin } from 'tiptap-vuetify'
// don't forget to import CSS styles
import 'tiptap-vuetify/dist/main.css'
// Vuetify's CSS styles
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify, {
	theme: {
		themes: {
			light: {
				primary: '#495ed8',
				secondary: '#424242',
				accent: '#6fa8dc',
				// one_more_accent: '#5681ab',
				one_more_accent: '#68a5c5',
				error: '#ff7a72',
				info: '#2196F3',
				success: '#4CAF50',
				warning: '#FFC107',
				background: '#f8f8f8',
			}
		}
	},
	icons: {
		iconfont: 'mdiSvg',
	},
})

const vuetify =new Vuetify({})

Vue.use(TiptapVuetifyPlugin, {
  // the next line is important! You need to provide the Vuetify Object to this place.
  vuetify, // same as "vuetify: vuetify"
  // optional, default to 'md' (default vuetify icons before v2.0.0)
  iconsGroup: 'md'
})

export default vuetify
